import { memo } from 'react'

const IconPhotoFill = ({
  width,
  height,
}: {
  width: number
  height: number
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 27 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.125 0C1.84683 0 0 1.84683 0 4.125V22.875C0 23.595 0.184457 24.2719 0.508692 24.861L17.2452 9.66577C17.6744 9.27739 18.3284 9.27817 18.7567 9.66757L27 17.2018V4.125C27 1.84683 25.1532 0 22.875 0H4.125ZM5.625 8.25C5.625 6.80025 6.80025 5.625 8.25 5.625C9.69975 5.625 10.875 6.80025 10.875 8.25C10.875 9.69975 9.69975 10.875 8.25 10.875C6.80025 10.875 5.625 9.69975 5.625 8.25Z'
        fill='#8E98A0'
        fillOpacity='0.6'
      />
      <path
        d='M4.125 27C3.38507 27 2.69065 26.8052 2.09022 26.464L17.9982 12.0188L26.9999 20.25L27 22.875C27 25.1532 25.1532 27 22.875 27H4.125Z'
        fill='#8E98A0'
        fillOpacity='0.6'
      />
    </svg>
  )
}

export default memo(IconPhotoFill)
